import React from 'react';
import { useWorkbook } from '@/context/WorkbookContext';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';

function SectionDivider(props) {
  const { number, title, subtitle, description, color } = props;
  const { setCurrentPage } = useWorkbook();
  
  const sectionColor = color || 'section-stability';
  
  function getNextPage() {
    const sectionMap = {
      'I': 'rule-1',
      'II': 'rule-5',
      'III': 'rule-9',
      'IV': 'rule-12',
      'V': 'life-money-map',
      'VI': 'glossary',
    };
    return sectionMap[number] || 'title';
  }
  
  function handleClick() {
    setCurrentPage(getNextPage());
  }
  
  return (
    <div className={`min-h-screen flex items-center justify-center p-8 ${sectionColor}`}>
      <div className="max-w-2xl text-center">
        <div className="mb-6">
          <span className="inline-block text-8xl md:text-9xl font-serif font-bold opacity-20 text-primary">
            {number}
          </span>
        </div>
        
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="h-px w-16 bg-border" />
          <span className="text-sm uppercase tracking-[0.3em] text-muted-foreground font-sans">
            Section {number}
          </span>
          <div className="h-px w-16 bg-border" />
        </div>
        
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4">
          {title}
        </h1>
        
        <p className="text-xl md:text-2xl text-muted-foreground font-serif italic mb-8">
          {subtitle}
        </p>
        
        <p className="text-base text-muted-foreground max-w-lg mx-auto mb-12 leading-relaxed">
          {description}
        </p>
        
        <Button 
          onClick={handleClick}
          className="gap-2 px-8"
          size="lg"
        >
          Begin Section
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}

export { SectionDivider };
